import Injector from 'vue-inject';
import Debug from '@/util/debug';

const debug = Debug('service:objectives');

export default class ObjectivesService {
  constructor(aas) {
    this.adApiService = aas;
    this.objectives = null;
    this.error = null;
  }

  loadObjectivesFromApi() {
    debug.info('loading from api');
    return this.adApiService.getObjectives()
      .then(objectives => this.objectives = objectives)
      .catch(err => {
        debug.warn('error while loading from api: %o', err);
        this.error = err;
        throw err;
      });
  }

  getObjectives() {
    debug.info('getObjectives err: %o, objectives: %o', this.error, this.objectives);
    if (this.error !== null) {
      return new Promise((resolve, reject) => reject(this.error));
    } else if (this.objectives) {
      return new Promise(resolve => resolve(this.objectives));
    }

    return this.loadObjectivesFromApi();
  }
}

Injector.service('objectivesService', ['adApiService'], ObjectivesService);



// WEBPACK FOOTER //
// ./src/services/ObjectivesService.js